/* ===========================================================================
   ne-image-lightbox.js

   Port of ImageLightbox.tsx (black-sea-marketplace) to vanilla JS for the
   Shopify PDP. The mechanics below mirror the source one for one:

     • zoom steps [1, 2, 3.5] and nextZoomStep()
     • zoomTo(scale, anchor) — the pixel under the cursor stays put
     • clampOffset() — pan is bounded by the scaled image against the viewport
     • wheel: scale * exp(-deltaY / 300), anchored at the cursor
     • pointer pan + two-finger pinch, movedRef guarding the click handler
     • touch swipe of >40px pages, but never while zoomed or after a drag
     • body scroll lock, focus into the dialog, Tab trap, focus restored to the
       element that opened it
     • neighbours preloaded so paging is instant
     • loadedIndex (not a boolean) so a cached image can't stay behind the
       spinner — the source's exact bug fix

   Differences, both from the brief rather than the source:
     • arrows disable at the ends; the source wraps with modulo
     • double click steps the zoom (1 → 2 → 3.5 → 1); the source single-clicks
       to toggle 1 ↔ 2
   The layout is the source's windowed gallery: a white card on a dimmed page,
   closed by clicking the overlay around it.
   =========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('ne-lightbox');
  var dataEl = document.getElementById('ne-lb-data');
  if (!root || !dataEl) return;

  var items = [];
  try { items = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
  if (!items.length) return;

  var MIN_SCALE = 1;
  var MAX_SCALE = 3.5;
  var ZOOM_STEPS = [1, 2, MAX_SCALE];

  function nextZoomStep(scale, direction) {
    if (direction === 1) {
      for (var i = 0; i < ZOOM_STEPS.length; i++) if (ZOOM_STEPS[i] > scale + 0.01) return ZOOM_STEPS[i];
      return MAX_SCALE;
    }
    for (var j = ZOOM_STEPS.length - 1; j >= 0; j--) if (ZOOM_STEPS[j] < scale - 0.01) return ZOOM_STEPS[j];
    return MIN_SCALE;
  }

  var stage    = document.getElementById('ne-lb-stage');
  var img      = document.getElementById('ne-lb-img');
  var spinner  = document.getElementById('ne-lb-spinner');
  var counter  = document.getElementById('ne-lb-counter');
  var prevBtn  = document.getElementById('ne-lb-prev');
  var nextBtn  = document.getElementById('ne-lb-next');
  var zoomIn   = document.getElementById('ne-lb-zoom-in');
  var zoomOut  = document.getElementById('ne-lb-zoom-out');
  var closeBtn = document.getElementById('ne-lb-close');
  var thumbsEl = document.getElementById('ne-lb-thumbs');
  var video    = document.getElementById('ne-lb-video');

  var current = 0;
  var loadedIndex = null;
  var view = { scale: 1, x: 0, y: 0 };
  var dragging = false;
  var opener = null;
  var multi = items.length > 1;

  var pointers = new Map();
  var panStart = null;
  var pinch = null;
  var moved = false;
  var touchX = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  /* ---- thumbnails ------------------------------------------------------- */

  items.forEach(function (m, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ne-lb__thumb';
    b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + items.length);
    var t = document.createElement('img');
    t.src = m.thumb;
    t.alt = m.alt || '';
    t.loading = 'lazy';
    b.appendChild(t);
    b.addEventListener('click', function () { show(i); });
    thumbsEl.appendChild(b);
  });
  var thumbBtns = [].slice.call(thumbsEl.children);

  /* ---- rendering -------------------------------------------------------- */

  function applyView() {
    img.style.transform = 'translate3d(' + view.x + 'px,' + view.y + 'px,0) scale(' + view.scale + ')';
    img.style.transition = dragging ? 'none' : 'transform 140ms ease-out';
    img.style.cursor = view.scale > 1 ? (dragging ? 'grabbing' : 'grab') : 'zoom-in';
    var onVideo = isVideo(current);
    if (zoomIn) zoomIn.disabled = onVideo || view.scale >= MAX_SCALE - 0.001;
    if (zoomOut) zoomOut.disabled = onVideo || view.scale <= MIN_SCALE + 0.001;
  }

  function paintLoading() {
    if (isVideo(current)) { spinner.hidden = true; return; }
    var ready = loadedIndex === current;
    img.style.opacity = ready ? '1' : '0';
    spinner.hidden = ready;
  }

  function isVideo(i) { return !!(items[i] && items[i].video); }

  /* A video slide takes the stage whole: the photo and its spinner hide, the
     zoom controls switch off (there is nothing to magnify, and the pan
     handlers would fight the scrubber), and leaving the slide stops playback
     rather than leaving audio running behind the next photo. */
  function stopVideo() {
    if (!video) return;
    video.pause();
    video.hidden = true;
    video.removeAttribute('src');
    video.load();
  }

  function show(i) {
    current = Math.max(0, Math.min(i, items.length - 1));
    view = { scale: 1, x: 0, y: 0 };   // a new photo always starts unzoomed
    dragging = false;

    var vid = isVideo(current);
    stage.classList.toggle('is-video', vid);
    if (vid && video) {
      var src = items[current].video;
      if (video.getAttribute('src') !== src) {
        video.setAttribute('src', src);
        video.poster = items[current].full || '';
        video.load();
      }
      video.hidden = false;
      loadedIndex = current;
    } else {
      stopVideo();
      img.src = items[current].full;
      img.alt = items[current].alt || '';
      // A cached image can be complete before any load event fires.
      loadedIndex = (img.complete && img.naturalWidth > 0) ? current : null;
    }
    paintLoading();
    applyView();
    if (counter) counter.textContent = (current + 1) + ' of ' + items.length;
    if (prevBtn) prevBtn.disabled = current === 0;          // no wrap-around
    if (nextBtn) nextBtn.disabled = current === items.length - 1;
    thumbBtns.forEach(function (b, n) {
      b.classList.toggle('is-on', n === current);
      b.setAttribute('aria-current', n === current ? 'true' : 'false');
    });
    preloadNeighbours();
  }

  img.addEventListener('load', function () { loadedIndex = current; paintLoading(); });
  img.addEventListener('error', function () { loadedIndex = current; paintLoading(); });

  function preloadNeighbours() {
    if (!multi) return;
    [-1, 1].forEach(function (step) {
      var n = current + step;
      if (n < 0 || n >= items.length) return;
      var pre = new Image();
      pre.src = items[n].full;
    });
  }

  function go(dir) {
    var n = current + dir;
    if (n < 0 || n >= items.length) return;   // ends are hard stops
    show(n);
  }

  /* ---- zoom ------------------------------------------------------------- */

  function clampOffset(next, scale) {
    if (scale <= 1) return { x: 0, y: 0 };
    var maxX = Math.max(0, (img.offsetWidth * scale - window.innerWidth) / 2);
    var maxY = Math.max(0, (img.offsetHeight * scale - window.innerHeight) / 2);
    return {
      x: Math.min(maxX, Math.max(-maxX, next.x)),
      y: Math.min(maxY, Math.max(-maxY, next.y))
    };
  }

  function zoomTo(nextScale, anchor) {
    var scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, nextScale));
    if (Math.abs(scale - view.scale) < 0.001) return;
    if (scale <= MIN_SCALE) { view = { scale: 1, x: 0, y: 0 }; applyView(); return; }
    var ax = (anchor && anchor.x != null ? anchor.x : window.innerWidth / 2) - window.innerWidth / 2;
    var ay = (anchor && anchor.y != null ? anchor.y : window.innerHeight / 2) - window.innerHeight / 2;
    var k = scale / view.scale;
    var shifted = { x: ax - k * (ax - view.x), y: ay - k * (ay - view.y) };
    var clamped = clampOffset(shifted, scale);
    view = { scale: scale, x: clamped.x, y: clamped.y };
    applyView();
  }

  stage.addEventListener('wheel', function (e) {
    if (isVideo(current)) return;          // let the page keep its own scroll
    e.preventDefault();
    zoomTo(view.scale * Math.exp(-e.deltaY / 300), { x: e.clientX, y: e.clientY });
  }, { passive: false });

  // Double click steps through the zoom; from the top step it resets to 1x.
  stage.addEventListener('dblclick', function (e) {
    if (isVideo(current)) return;
    e.preventDefault();
    var next = view.scale >= MAX_SCALE - 0.001 ? MIN_SCALE : nextZoomStep(view.scale, 1);
    zoomTo(next, { x: e.clientX, y: e.clientY });
  });

  if (zoomIn) zoomIn.addEventListener('click', function (e) { e.stopPropagation(); zoomTo(nextZoomStep(view.scale, 1)); });
  if (zoomOut) zoomOut.addEventListener('click', function (e) { e.stopPropagation(); zoomTo(nextZoomStep(view.scale, -1)); });

  /* ---- pan / pinch ------------------------------------------------------ */

  stage.addEventListener('pointerdown', function (e) {
    // the video owns its own pointer: dragging a scrubber must not pan a frame
    if (isVideo(current)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    moved = false;
    if (pointers.size === 2) {
      var v = [].slice.call(pointers.values());
      pinch = { dist: Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y), scale: view.scale };
      panStart = null;
      dragging = true;
      applyView();
      return;
    }
    if (pointers.size === 1 && view.scale > 1) {
      panStart = { px: e.clientX, py: e.clientY, ox: view.x, oy: view.y };
      dragging = true;
      applyView();
      if (stage.setPointerCapture) stage.setPointerCapture(e.pointerId);
    }
  });

  stage.addEventListener('pointermove', function (e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    if (pointers.size >= 2 && pinch && pinch.dist > 0) {
      var v = [].slice.call(pointers.values());
      moved = true;
      zoomTo(pinch.scale * (Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) / pinch.dist),
             { x: (v[0].x + v[1].x) / 2, y: (v[0].y + v[1].y) / 2 });
      return;
    }
    if (!panStart) return;
    var dx = e.clientX - panStart.px;
    var dy = e.clientY - panStart.py;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
    if (view.scale <= 1) return;
    var c = clampOffset({ x: panStart.ox + dx, y: panStart.oy + dy }, view.scale);
    view.x = c.x; view.y = c.y;
    applyView();
  });

  function endPointer(e) {
    pointers.delete(e.pointerId);
    if (pointers.size < 2) pinch = null;
    if (pointers.size === 0) {
      panStart = null;
      dragging = false;
      applyView();
      // `moved` has to survive just long enough for the click that follows a
      // drag to be ignored, then clear — otherwise one pan earlier in the
      // session would keep the backdrop from ever closing again.
      setTimeout(function () { moved = false; }, 0);
    }
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);

  /* ---- swipe / backdrop ------------------------------------------------- */

  root.addEventListener('touchstart', function (e) {
    touchX = e.changedTouches[0] ? e.changedTouches[0].clientX : null;
  }, { passive: true });

  root.addEventListener('touchend', function (e) {
    var start = touchX;
    touchX = null;
    if (start == null || !multi) return;
    if (view.scale > 1 || moved) return;      // a pan or pinch is not a swipe
    var dx = (e.changedTouches[0] ? e.changedTouches[0].clientX : start) - start;
    if (Math.abs(dx) < 40) return;
    go(dx < 0 ? 1 : -1);
  }, { passive: true });

  // Anywhere on the dimmed overlay outside the window closes; anything inside
  // the window does not. Guarded so a drag that ends outside cannot close it.
  root.addEventListener('click', function (e) {
    if (e.target !== root) return;
    if (moved) return;
    close();
  });

  /* ---- open / close ----------------------------------------------------- */

  function open(index) {
    opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    root.hidden = false;
    document.documentElement.classList.add('ne-lb-locked');
    document.body.classList.add('ne-lb-locked');
    show(index || 0);
    void root.offsetWidth;
    root.classList.add('is-open');
    (closeBtn || root).focus({ preventScroll: true });
    window.addEventListener('keydown', onKey, true);
  }

  function close() {
    stopVideo();
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.classList.remove('ne-lb-locked');
    document.body.classList.remove('ne-lb-locked');
    window.removeEventListener('keydown', onKey, true);
    var back = opener;
    opener = null;
    if (back && document.contains(back) && back.focus) back.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowLeft') { go(-1); return; }
    if (e.key === 'ArrowRight') { go(1); return; }
    if (e.key !== 'Tab') return;
    var nodes = [].slice.call(root.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!nodes.length) { e.preventDefault(); root.focus(); return; }
    var first = nodes[0], last = nodes[nodes.length - 1], active = document.activeElement;
    if (!e.shiftKey && (active === last || !root.contains(active))) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (active === first || !root.contains(active))) { e.preventDefault(); last.focus(); }
  }

  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

  /* ---- triggers on the page gallery ------------------------------------- */

  // Which photo was clicked: the stage mirrors whichever thumb is active, so
  // match on the thumbnail rail's current selection, then fall back to 0.
  function activeIndex() {
    // The rail is capped at seven tiles while this list holds every photo and
    // video, so position in the rail is not position here — each tile states
    // its own index, and only a tile without one falls back to counting.
    var thumbs = document.querySelectorAll('#ne-thumbs button');
    for (var i = 0; i < thumbs.length; i++) {
      if (!thumbs[i].classList.contains('is-on')) continue;
      var stated = thumbs[i].getAttribute('data-lb-index');
      return stated === null ? i : (parseInt(stated, 10) || 0);
    }
    return 0;
  }

  var pageStage = document.getElementById('ne-stage');
  if (pageStage) {
    pageStage.addEventListener('click', function () {
      // a video on the stage is being operated, not previewed — its own
      // controls get the click, and the viewer stays shut
      if (pageStage.classList.contains('is-video')) return;
      open(activeIndex());
    });
  }

  // The page asks for the viewer by event rather than by a global, so the
  // gallery script needs no handle on this one — the "+N" tile uses it to open
  // on the first photo the rail had to hide.
  document.addEventListener('ne:lightbox-open', function (e) {
    open((e.detail && e.detail.index) || 0);
  });

  // Mobile swipe strip: tapping a slide opens that slide's photo. A video slide
  // plays in place instead, so it is left alone.
  var slides = document.querySelectorAll('#ne-slides .slide');
  [].forEach.call(slides, function (slide, i) {
    if (slide.classList.contains('slide--video')) return;
    slide.addEventListener('click', function () { open(i); });
  });
})();
